import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { safetyMargins } from '@bedrock-rdk/constants';
import { Scroll } from '../../../tornado/programInformation/scroll/scroll.component';
import { ProgramDescription } from '../../../tornado/programInformation/description/programDescription.component';
import { SCREEN_HEIGHT } from '../../../tornado/utils/sizes';
import {
  defaultContext,
  getInitialStyle,
  getUnFocusedStyle,
  getFocusedStyle,
  TEXT_WIDTH,
  PADDING_TOP,
  GAP,
} from './programInformation.style';
import { PROGRAM_INFORMATION_CLOSED_SIGNAL } from './programInformation.constants';
import connect from './programInformation.connector';

export class ProgramInformation extends Lightning.Component {
  static _template() {
    return _merge(
      {
        rect: true,
        BackgroundOverlay: {
          rect: true,
        },
        Title: {},
        Scroll: {
          type: Scroll,
          content: {
            type: ProgramDescription,
            w: TEXT_WIDTH[defaultContext.screenSize],
          },
        },
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
  }

  _detach() {
    this.tag('Title').removeAllListeners('txLoaded');
    if (this._unsubscribe) {
      this._unsubscribe();
    }
  }

  _active() {
    if (!this._unsubscribe) {
      this._unsubscribe = connect(this);
    }
  }

  set data(content) {
    if (!content) {
      return;
    }

    this.tag('Title').once('txLoaded', () => {
      const scroll = this.tag('Scroll');
      const scrollableView = scroll.content;
      if (scrollableView) {
        const titleHeight = this.tag('Title').finalH;
        const { screenSize } = this._style;
        scroll.visible = true;
        scroll.y = titleHeight + PADDING_TOP[screenSize] + GAP[screenSize];
        scroll.h = SCREEN_HEIGHT[screenSize] - scroll.y - safetyMargins.vertical[screenSize];
        scrollableView.data = {
          description: content.description,
        };
      }
    });

    this.tag('Title').text.text = content.title;
  }

  _getFocused() {
    return this.tag('Scroll');
  }

  _unfocus() {
    this.patch(getUnFocusedStyle(this._style.screenSize));
  }

  _focus() {
    this.patch(getFocusedStyle(this._style.screenSize));
  }

  _handleBack() {
    this.signal(PROGRAM_INFORMATION_CLOSED_SIGNAL);
  }

  _handleLeft() {
    this.signal(PROGRAM_INFORMATION_CLOSED_SIGNAL);
  }
}
